import React from 'react'
export const ListSideText: React.FC<{text: string}> = ({text}) => {
  return (
    <div>
      <p className="text-[14px] leading-[25px] font-light text-primary text-right">{text}</p>
    </div>
  )
}
